import React, {Fragment, useState} from 'react';
import {logoutUser} from '../../actions';
import {connect} from "src/store";
import classNames from "classnames";
import Modal from "./Modal";
import TextInput from "../form/TextInput";
import Portal from "./Portal";
import {sendRequest} from "../../utils/request";
import Icon from "../form/Icon";
import { Link } from 'react-router-dom';
import md5 from "locutus/php/strings/md5";
import ModalEditor from "../editors/ModalEditor";
import Button from "../form/Button";
import DeliveryEditor from "../editors/DeliveryEditor";
import FragmentEditor from "../editors/FragmentEditor";

/*let time = null;

window.blur = () => {
    time = new Date().getTime();
};
window.focus = () => {
    if (time !== null && time + 3600000 < new Date().getTime()) {
        window.location.reload(true);
    } else {
        time = null;
    }
};*/

const RefreshButton = () => {
    return <a href="#" className="btn btn-default btn-flat" onClick={(e) => {
        e && e.preventDefault();
        window.location.reload(true);
    }}><Icon lib="fa" name="refresh" /></a>;
}

const DeliveryModalEditor = connect((state) => {
    return {
        user: state.app.user
    };
})(React.forwardRef((props, ref) => {
    const [opened, setOpened] = useState(false);
    return <Fragment>
        <Button
            color="default"
            className="btn btn-default btn-flat btn-block mb-2"
            onClick={() => setOpened(true)}
        >
            Csomagom érkezik
        </Button>
        <Portal>
            <Modal
                size="large"
                state={opened}
                header="Csomagom érkezik"
                buttons={[
                    {
                        text: 'Bezárás',
                        props: {color: "default"},
                        onClose: true,
                        onClick: () => {
                            setOpened(false);
                        }
                    },
                ]}
            >
                <DeliveryEditor
                    ref={ref}
                    editorContext="MainMenuDelivery"
                    listFilter={{field: "recipient", value: props.user.id}}
                    list={FragmentEditor}
                    editor={FragmentEditor}
                    {...props}
                />
            </Modal>
        </Portal>
    </Fragment>
}));



class MainUserMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            opened: props.opened !== undefined ? props.opened : false,
            debug: null,
            disabled: false
        };
        this.wrapperRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.setState({opened: false});
        }
    }

    toggle = (e) => {
        e.preventDefault();
        this.setState({opened: !this.state.opened});
    }

    render() {
        const user = this.props.user;
        return <li ref={this.wrapperRef} className={classNames("dropdown user user-menu", {open: this.state.opened})}>
            <a href="" onClick={this.toggle} className="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                <img
                    src={"https://www.gravatar.com/avatar/" + md5(user.email) + "?d=mp"}
                    className="user-image"
                    alt={user.name}
                />
                <span className="d-none d-md-inline">{user.name}</span>
            </a>
            <ul className="dropdown-menu">
                <li className="user-header">
                    <img
                        src={"https://www.gravatar.com/avatar/" + md5(user.email) + "?d=mp"}
                        className="img-circle"
                        alt={user.name}
                    />
                    <p>
                        <Link style={{color: "white"}} to="?option=currentuser">{user.name}</Link>
                        <small>{user.email}</small>
                    </p>
                </li>
                <li className="user-footer">
                    {window.location.hostname === "localhost" &&
                        <Fragment>
                            <Portal>
                                <Modal
                                    header="debug_password"
                                    ref={(debugModal) => this.debugModal = debugModal}
                                    disabled={this.state.disabled}
                                    buttons={[
                                        {
                                            text: "Mégse",
                                            props: {color: "default", disabled: this.state.disabled},
                                            onClose: true,
                                            onClick: () => {
                                                this.debugModal && this.debugModal.hide();
                                            }
                                        },
                                        {
                                            text: "Debug",
                                            props: {color: "primary", disabled: this.state.disabled},
                                            onClose: true,
                                            onClick: async () => {
                                                this.setState({disabled: true}, async () => {
                                                    await sendRequest({debug: this.state.debug});
                                                    this.debugModal && this.debugModal.hide();
                                                    this.setState({disabled: false});
                                                });
                                            }
                                        }
                                    ]}
                                >
                                    <TextInput name="debug" label={false} saveChanges={(field, debug) => this.setState({debug})}/>
                                </Modal>
                            </Portal>
                            <div style={{marginBottom: "10px"}}>
                                <a className="btn btn-warning btn-flat btn-block" onClick={(e) => {
                                    e && e.preventDefault();
                                    this.debugModal && this.debugModal.focus();
                                }}>
                                    Debug
                                </a>
                            </div>
                        </Fragment>}
                    {/*<div className="row form-row">*/}
                    {/*<div className="pull-left">*/}
                    {/*    <RefreshButton />*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    <Link className="btn btn-flat btn-default btn-block mb-2" to="?option=currentuser">Profil</Link>
                    <DeliveryModalEditor />
                    <a href="#" className="btn btn-default btn-flat btn-block mb-2" onClick={(e) => {
                        e && e.preventDefault();
                        this.props.logoutUser();
                    }}>Kijelentkezés</a>

                </li>
            </ul>
        </li>;
    }
}

export default connect((state) => { return {user: state.app.user}}, {logoutUser})(MainUserMenu);
